'use strict';
Object.defineProperty(exports, '__esModule', { value: !0 }), exports.transform = void 0;
var transform = function (r) {
    return {
        MozTransformStyle: r,
        WebkitTransform: r,
        OTransform: r,
        msTransform: r,
        transform: r
    };
};
exports.transform = transform;